import loadable from '@loadable/component';
import { MediaLoader } from '../../../../../shared/index.ts';
import { LoadableFunctionalComponent } from '../../../../../utils/index.ts';
import { ImageFieldComponentViewProps } from './component/types.ts';

export const ImageField = loadable(() => import('./component/index.tsx'), {
  resolveComponent: (components) => components.ImageFieldComponent,
  fallback: <MediaLoader />,
}) as LoadableFunctionalComponent<ImageFieldComponentViewProps>;
